import adapter from '../adapter-bookings-service';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.BOOKINGS_SERVICE,
    schema: "{{" + IDs.SD_JSON_RENDER + "}}",
};
